import { Badge } from '@/components/ui/badge';

import type { KnowledgeDocumentStatus } from '../types';

const LABELS: Record<KnowledgeDocumentStatus, string> = {
  pending: 'Pending',
  indexed: 'Indexed',
  stale: 'Stale',
  failed: 'Failed',
};

/** Colour-coded pill for a document's indexing state. */
export function DocumentStatusBadge({ status }: { status: KnowledgeDocumentStatus }) {
  if (status === 'indexed') return <Badge className="bg-emerald-600">{LABELS.indexed}</Badge>;
  if (status === 'failed') return <Badge variant="destructive">{LABELS.failed}</Badge>;
  if (status === 'stale')
    return (
      <Badge className="bg-amber-500 text-white" title="Source changed since last index">
        {LABELS.stale}
      </Badge>
    );
  return <Badge variant="secondary">{LABELS.pending}</Badge>;
}
